import PropTypes from 'prop-types'
import {Tag, TagLabel} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {useRails} from '~/react/contexts/rails'

const PROVIDER_COLOURS = {
  Xero: 'provider.xero',
  Quickbooks: 'provider.quickbooks',
  MYOB: 'provider.myob',
}

const DEFAULT_COLOUR = 'provider.xero'

export const AccountingProviderImportTag = ({singular}) => {
  const {t} = useTranslation('pointsOnPayments')
  const {accountingProvider} = useRails()
  const providerName = accountingProvider?.name

  const colour = PROVIDER_COLOURS[providerName] || DEFAULT_COLOUR

  const label = singular
    ? t('accountingProviderImportTag.singular', {providerName})
    : t('accountingProviderImportTag.plural', {providerName})

  return (
    <Tag variant="status" backgroundColor={colour}>
      <TagLabel color="white">{label}</TagLabel>
    </Tag>
  )
}

AccountingProviderImportTag.defaultProps = {
  singular: false,
}

AccountingProviderImportTag.propTypes = {
  singular: PropTypes.bool,
}
